import apiCrud from '../../abstract/api-crud';

const baseUri = `${ import.meta.env.VITE_SITE_URL }/crms/subscription-orders`;
export const modelName = 'subscriptionorder';

export default {
  ...apiCrud({ baseUri, modelName }),
  summaries: async (data) => await axios.post(`${ baseUri }/summaries`, data),
  offers: async () => await axios.get(`${ baseUri }/offers`),
};
